// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3CIy2","modalFooterButton":"ModalNotes_modalFooterButton__1fSJ2"};